import { KpiSkeleton } from '#core/components/dashboard/panels/kpi/KpiSkeleton.tsx';
import { KpiSchema } from '#core/components/dashboard/panels/kpi/schema.ts';

import { createGridComponent } from '../shared/helpers.ts';
import { AlertKpi } from './variants/AlertKpi.tsx';
import { StandardKpi } from './variants/StandardKpi.tsx';

/**
 * Unified KPI (Key Performance Indicator) component.
 *
 * Supports two display variants:
 * 1. **Standard KPI**: Clean bordered card with value, label, and optional trend indicator.
 *    Used when neither `color` nor `kind` props are provided.
 *
 * 2. **Alert KPI**: Colored gradient background with optional emergency styling.
 *    Used when `color` and/or `kind` props are provided. Ideal for critical metrics,
 *    warnings, or status indicators that need visual emphasis.
 *
 * This is a pure renderer - receives all data as props, no internal data fetching.
 * Works in both dashboard grid and chat block contexts.
 *
 * @example Standard KPI
 * ```tsx
 * <Kpi value={1234} label="Total Orders" unit="orders" trend="up" trendValue={5.2} />
 * ```
 *
 * @example Alert KPI (colored)
 * ```tsx
 * <Kpi value={3} label="Critical Alerts" color="red" kind="emergency" />
 * ```
 */
export const Kpi = createGridComponent(
  (props) => {
    const isAlertStyle = props.color !== undefined || props.kind !== undefined;
    return isAlertStyle ? <AlertKpi {...props} /> : <StandardKpi {...props} />;
  },
  KpiSchema,
  KpiSkeleton,
);
